<template>
  <div>
    <Breadcrumb :options="breadcrumb" />

    <SearchField :form="formInline" :formCtrl="formCtrl" @onSearch="onSearch" @onReset="onReset">
      <template #start>
        <el-form-item class="startBtn">
          <el-button type="primary" icon="el-icon-plus" @click="add">添加</el-button>
        </el-form-item>
      </template>
    </SearchField>

    <Table ref="table" :tableData="tableData" :cols="cols" :page="page" :limit="limit" :total="total" :btns="btns"
      :allBtnWidth="allBtnWidth" @onSelectionChange="onSelectionChange" @onCurrentChange="onCurrentChange"
      @onSizeChange="onSizeChange">
      <template slot="car_type" slot-scope="params">
        <span v-if="params.params.car_type == 1">车头</span>
        <span v-if="params.params.car_type == 2">挂车</span>
      </template>
      <template slot="isdisplay" slot-scope="params">
        <MySwitch :data="params.params" :activeValue="`1`" :inactiveValue="`2`" @onToggle="toggleDisplay"></MySwitch>
      </template>
    </Table>

    <FormDialog ref="dialog" :title="title" :width="'548px'" :labelWidth="'110px'" :form="mform" :rules="mrules"
      :formCtrl="mformCtrl" :viewMode="viewMode" @onModalSubmit="onModalSubmit"></FormDialog>
  </div>
</template>

<script>
import tableMixin from "../../mixin/table";
import systermMixin from "../mixin";

export default {
  mixins: [tableMixin, systermMixin],
  data() {
    return {
      baseUrl: 'documentauth',
      breadcrumb: [
        { name: "系统设置" },
        { name: "车辆证件配置" },
      ],
      formCtrl: [
        {
          label: "证件名称",
          keyName: "type_name",
          placeholder: "请填写证件名称",
          type: "text",
        },
      ],
      cols: [
        { keyName: "type_name", label: "证件名称", minwidth: 120 },
        { keyName: "car_type", label: "种类", slot: 'car_type', minwidth: 120 },
        { keyName: "nickname", label: "创建人", minwidth: 120 },
        { keyName: "sort", label: "排序", minwidth: 120 },
        { keyName: "is_display", label: "是否显示", slot: 'isdisplay', minwidth: 120 },
        { keyName: "created_at", label: "添加时间", minwidth: 120 },
      ],
      title: '添加车辆证件',
      mform: {},
      mrules: {
        type_name: [
          {
            required: true,
            message: '请填写证件名称',
            trigger: 'blur',
          }
        ],
      },
      mformCtrl: [
        {
          label: "证件名称",
          keyName: "type_name",
          err: "请填写证件名称",
          type: "text",
        },
        {
          label: "种类",
          keyName: "car_type",
          type: "radio",
          options: [
            { label: '车头', value: 1 },
            { label: '挂车', value: 2 },
          ],
        },
        {
          label: "排序",
          keyName: "sort",
          err: "请填写排序",
          type: "number",
          tips: "数字越小排序越靠前",
        },
        {
          label: "是否显示",
          keyName: "is_display",
          type: "radio",
          options: [
            { label: '是', value: 1 },
            { label: '否', value: 2 },
          ],
        },
      ],
    };
  },
  methods: {
    add() {
      delete this.mform.id
      this.mform = {
        type_name: undefined,
        car_type: 1,
        is_display: 1,
      }
      this.title = this.title.replace('修改', '添加')
      this.showDialog()
    },
    getItem({ id, type_name, is_display, sort, car_type }) {
      this.mform = { ...this.mform, id, type_name, sort, is_display, car_type }
      this.title = this.title.replace('添加', '修改')
    },
    toggleDisplay({ id, is_display, name, car_type, type_name }) {
      // console.log(id)
      let display = (is_display === 1 ? 2 : 1)
      let url = `${this.baseUrl}/${this.modalSubmitUrl}`;
      const params = {
        userid: this.user.id,
        id,
        is_display: display,
        car_type,
        type_name,
      }
      if (name) params['name'] = name
      this.post(url, params, ({ msg }) => {
        if (msg === 'success') {
          this.$message({
            type: 'success',
            message: '修改成功!',
          });
          this.getList(true)
        } else {
          this.$message({
            type: 'error',
            message: msg,
          });
          // 禁止隐藏，并刷新
          this.getList()
        }
      }, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '提交失败，请稍后重试！'
        });
      })
    },
  },
};
</script>

<style lang="less" scoped>
/deep/ .dialog {
  .el-form {
    padding-right: 0 !important;

    .el-input {
      width: 230px;
    }
  }
}
</style>
